import { styled } from '../../Utilities';
import { SliderBase } from './Slider.base';
import { getStyles } from './Slider.styles';
export var Slider = styled(SliderBase, getStyles, undefined, {
    scope: 'Slider',
});
//# sourceMappingURL=Slider.js.map